import { render, staticRenderFns } from "./JoinToModuleComponent.vue?vue&type=template&id=6e77b442&scoped=true"
import script from "./JoinToModuleComponent.vue?vue&type=script&lang=js"
export * from "./JoinToModuleComponent.vue?vue&type=script&lang=js"
import style0 from "./JoinToModuleComponent.vue?vue&type=style&index=0&id=6e77b442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e77b442",
  null
  
)

export default component.exports